import { BaseIdNotRequiredRequest } from "../../../base/request/BaseIdNotRequiredRequest";
import { AplicacionRecipienteResponse } from "../response/AplicacionRecipienteResponse";

/** Request de creación/edición de un recipiente de aplicación. `id` null =
 *  crear, con valor = editar. Siempre queda asociado a `clienteId`: este rpc no
 *  crea ni convierte recipientes globales. */
export type AplicacionRecipienteRequest = BaseIdNotRequiredRequest & {
  /** Cliente dueño del recipiente. */
  clienteId: string;
  /** Nombre (único entre los activos, globales y del cliente). */
  nombre: string;
  /** Litros que le caben. El server exige > 0: es el factor que convierte
   *  recipientes en litros, y en cero toda mezcla daría cero. */
  litros: number;
};

export const fx_createAplicacionRecipienteRequestEmpty = (
  clienteId: string,
): AplicacionRecipienteRequest => {
  return {
    id: null,
    clienteId,
    nombre: "",
    litros: 0,
  };
};

export const fx_createAplicacionRecipienteRequest = (
  recipiente: AplicacionRecipienteResponse,
): AplicacionRecipienteRequest => {
  return {
    id: recipiente.id,
    clienteId: recipiente.clienteId,
    nombre: recipiente.nombre,
    litros: recipiente.litros,
  };
};
